import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=315ed87d&scoped=true&"
import script from "./Addons.vue?vue&type=script&lang=js&"
export * from "./Addons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ed87d",
  null
  
)

export default component.exports